import Util from '../RegistrationUtil'
import Field from '../RegistrationField'

function GPA(opts) {
    Field.call(this, opts)

    this.$input = this.$html.find('input')
}

Util.inherit(GPA, Field, {
    getClassName: function() {
        return 'textbox'
    },

    buildHtml: function() {
        return (
            '<input type="number" ' +
            'step="0.1" ' +
            'min="0" ' +
            'max="4" ' +
            this._getPlaceholderText() +
            ' ' +
            this._getAltText() +
            ' id="' +
            this._getId() +
            '" />'
        )
    },

    applyBindings: function() {
        var self = this

        this.$input.on('change', function() {
            self.setValue($(this).val())
        })
        this.$input.on('focus', this.focus.bind(this))
        this.$input.on('blur', this.blur.bind(this))
    },

    updateView: function() {
        Field.prototype.updateView.call(this)
        this.$input.val(this.value)
    },
})

export default GPA
